import { css, styled } from '@mui/material';

import { PALETTE } from '../../../theme/palette';
import { promotionCarouselSliderHeight } from '../PromotionCarousel/PromotionCarousel.styled';

export const StyledAdditionalDentoloInsuranceCard = styled('div')(
  ({ theme }) => css`
    background-color: ${PALETTE.ULTRA_CLEAR_LIGHT_BLUE};
    display: flex;
    flex-direction: column;
    height: ${promotionCarouselSliderHeight.mobile};
    justify-content: space-between;
    padding: ${theme.spacing('LARGE')};

    ${theme.breakpoints.up('desktop')} {
      height: ${promotionCarouselSliderHeight.desktop};
      padding: ${theme.spacing('1XL')};
    }
  `
);

export const StyledAdditionalDentoloInsuranceCardContent = styled('div')(
  ({ theme }) => css`
    column-gap: ${theme.spacing('LARGE')};
    display: flex;
    justify-content: space-between;

    ${theme.breakpoints.up('desktop')} {
      height: 100%;
    }
  `
);

export const StyledAdditionalDentoloInsuranceCardTextContent = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    row-gap: ${theme.spacing('XSMALL')};

    ${theme.breakpoints.up('desktop')} {
      justify-content: space-between;
    }
  `
);

export const StyledAdditionalDentoloInsuranceCardTitle = styled('div')`
  > h2,
  h3 {
    display: inline;
    padding-left: 2px;
    padding-right: 2px;
    background: linear-gradient(to bottom, transparent 62%, ${PALETTE.VITALIZED_GREEN} 38%);
    background-repeat: no-repeat;
  }
`;

export const StyledAdditionalDentoloInsuranceCardImage = styled('img')(
  ({ theme }) => css`
    height: 7.75rem;

    ${theme.breakpoints.up('desktop')} {
      height: 100%;
    }
  `
);
